import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';

import { Header } from './styles';

import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { PROVIDER_NAME_HEADER_ID } from '../../lib/constants';

interface ProviderNameProps {
  /** The provider whose name is displayed. */
  provider: ProviderMatchProviderV9;
}

const ProviderName = ({ provider }: ProviderNameProps): React.ReactElement => {
  const fullName = provider.name.full;
  const degrees =
    Array.isArray(provider.degrees) && provider.degrees.length
      ? provider.degrees.map(({ name }: { name: string }, index: number) => {
          const markup = (
            <span
              key={name + index}
              itemProp="hasCredential"
              itemScope={true}
              itemType="https://schema.org/EducationalOccupationalCredential"
            >
              <span itemProp="name">{name}</span>
            </span>
          );
          const isLast = index === provider.degrees.length - 1;

          if (isLast) {
            return markup;
          }

          return <>{markup}, </>;
        })
      : null;

  return (
    <Header id={PROVIDER_NAME_HEADER_ID}>
      <span itemProp="name">{fullName}</span>
      {degrees && <>, {degrees}</>}
    </Header>
  );
};

export default withErrorBoundary(ProviderName);
